import { View, Text } from 'react-native';
import React from 'react';
import { ProductDetailStyles } from './styles';
import { getPriceText } from '../../utils/NumberUtility';
import { isDesktop, isPresent } from '../../utils/BooleanUtility';
import colors from '../../theme/Colors';

const ProductPrice = ({ sp, mrp, discount, removePadding = false, outOfStock, prepaid_esp_offer, selectedVariantPrepaidEspOffer }) => {
  const discountToShow = discount?.toString()?.includes('off') ? discount : `${discount}% off`;
  return (
    <View
      style={[
        ProductDetailStyles.pricingContainerTop,
        removePadding && { paddingLeft: 0 },
        outOfStock && isDesktop() && { backgroundColor: colors.transparent },
      ]}
    >
      <View style={{ flexDirection: 'row' }}>
        <Text style={ProductDetailStyles.spStyle}>{`${getPriceText(parseFloat(sp))} `}</Text>
        {parseFloat(mrp) !== parseFloat(sp) && (
          <Text style={ProductDetailStyles.mrpStyle}>{`${getPriceText(mrp)} `}</Text>
        )}
        {parseFloat(mrp) !== parseFloat(sp) && isPresent(discount) && (
          <View style={ProductDetailStyles.discountContainer}>
            <Text style={ProductDetailStyles.discountRateStyle}>
              {discountToShow}
            </Text>
            {prepaid_esp_offer || selectedVariantPrepaidEspOffer && (
              <Text style={ProductDetailStyles.prePaidDiscountText}>
                Prepaid Only
              </Text>
            )}
          </View>
        )}
      </View>
    </View>
  );
};

export default React.memo(ProductPrice);

